import { createTheme } from '@mui/material/styles';
import { defaultTheme } from 'react-admin';

const VELORA_PRIMARY   = '#0176BC';
const VELORA_SECONDARY = '#4DDCD8';
const VELORA_DARK      = '#1B1E25';

export const veloraTheme = createTheme({
    ...defaultTheme,
    palette: {
        primary: {
            main:         VELORA_PRIMARY,
            dark:         '#015a8e',
            light:        '#3394cc',
            contrastText: '#ffffff',
        },
        secondary: {
            main:         VELORA_SECONDARY,
            dark:         '#2fb8b4',
            light:        '#80e8e5',
            contrastText: VELORA_DARK,
        },
        background: {
            default: '#f0f4f8',
            paper:   '#ffffff',
        },
        text: {
            primary:   VELORA_DARK,
            secondary: '#5a6072',
        },
        success: { main: '#10b981' },
        warning: { main: '#f59e0b' },
        error:   { main: '#ef4444' },
    },
    shape: {
        borderRadius: 10,
    },
    // react-admin lee aquí el ancho del menú lateral (240 por defecto). Con Poppins, «Sugerencias y
    // Feedback» no cabía; 260 queda cerca de los 265 del Sidebar de freezer.
    sidebar: {
        width: 260,
        closedWidth: 55,
    },
    typography: {
        fontFamily: '"Poppins", "Roboto", sans-serif',
        fontSize: 13,
        h1: { fontWeight: 700 },
        h2: { fontWeight: 700 },
        h3: { fontWeight: 700 },
        h4: { fontWeight: 600 },
        h5: { fontWeight: 600 },
        h6: { fontWeight: 600 },
        subtitle1: { fontWeight: 500 },
        button: {
            textTransform: 'none',
            fontWeight: 600,
            letterSpacing: 0.2,
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    boxShadow: 'none',
                    '&:hover': { boxShadow: 'none' },
                },
                contained: {
                    color: '#ffffff !important',
                    '& .MuiSvgIcon-root': { color: '#ffffff !important' },
                    '& .MuiButton-startIcon': { color: '#ffffff !important' },
                    '& .MuiButton-endIcon':   { color: '#ffffff !important' },
                },
                containedPrimary: {
                    background: `linear-gradient(135deg, ${VELORA_PRIMARY} 0%, #015a8e 100%) !important`,
                    color: '#ffffff !important',
                },
                containedError: {
                    color: '#ffffff !important',
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: { backgroundImage: 'none' },
                elevation1: {
                    boxShadow: '0 1px 3px rgba(0,0,0,0.07), 0 1px 2px rgba(0,0,0,0.05)',
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                head: {
                    fontWeight: 700,
                    fontSize: '0.75rem',
                    textTransform: 'uppercase',
                    letterSpacing: 0.5,
                    color: '#5a6072',
                    backgroundColor: '#f8fafc',
                },
            },
        },
        MuiTableRow: {
            styleOverrides: {
                root: {
                    '&:last-child td': { borderBottom: 0 },
                    '&:hover': { backgroundColor: '#f0f7fc !important' },
                },
            },
        },
        MuiChip: {
            styleOverrides: {
                root: { fontWeight: 500 },
                colorPrimary: {
                    backgroundColor: '#e0f0fb',
                    color: VELORA_PRIMARY,
                },
            },
        },
        MuiTextField: {
            defaultProps: { variant: 'standard' },
        },
        MuiSelect: {
            defaultProps: { variant: 'standard' },
        },
        MuiInputBase: {
            styleOverrides: {
                root: {
                    '&:before': { borderColor: '#cbd5e1' },
                    '&:hover:not(.Mui-disabled):before': { borderBottomColor: `${VELORA_PRIMARY} !important` },
                    '&:after': { borderBottomColor: VELORA_PRIMARY },
                },
            },
        },
        RaMenuItemLink: {
            styleOverrides: {
                // Compacto, en la línea del Sidebar de freezer: 13 px, peso 400 (600 el activo) y filas
                // de 36 px en lugar de los 48 px por defecto de MenuItem.
                root: {
                    borderRadius: 8,
                    margin: '1px 8px',
                    minHeight: 36,
                    paddingTop: 6,
                    paddingBottom: 6,
                    fontSize: '13px',
                    lineHeight: 1.4,
                    color: VELORA_DARK,
                    fontWeight: 400,
                    '& .MuiListItemIcon-root': { color: '#8a92a6' },
                    '&:hover': {
                        backgroundColor: `rgba(77,220,216,0.18)`,
                        color: VELORA_PRIMARY,
                        '& .MuiListItemIcon-root': { color: VELORA_PRIMARY },
                    },
                    '&.RaMenuItemLink-active': {
                        backgroundColor: `rgba(77,220,216,0.25)`,
                        color: VELORA_PRIMARY,
                        fontWeight: 600,
                        borderLeft: `3px solid ${VELORA_SECONDARY}`,
                        '& .MuiListItemIcon-root': { color: VELORA_SECONDARY },
                    },
                },
            },
        },
    },
});
